<mat-form-field appearance="fill">
    <mat-label>{{ 'select_dataset' | translate }}</mat-label>
    <input
      matInput
      [formControl]="datasetCtrl"
      [matAutocomplete]="auto" required>
  
    <mat-autocomplete #auto="matAutocomplete"
      (optionSelected)="datasetSelected($event)" [displayWith]="autocompleteDisplay">
      <mat-option *ngFor="let dataset of filteredDatasets" [value]="dataset"
        [matTooltip]="dataset.file" matTooltipPosition="right">
        {{dataset.name}}
      </mat-option>
      <mat-divider></mat-divider>
      <div fxLayout="row" fxLayoutAlign="end center">
        <button mat-flat-button (click)="clear()">
          <mat-icon>clear</mat-icon>
          {{ 'clear' | translate }}
        </button>
      </div>
    </mat-autocomplete>
  </mat-form-field>